import React from "react";
import Banner from "../components/Banner/Banner";
import Header from "../components/Header/Header";
import ROI from "../components/ROISection/ROI";
import UseCases from "../components/UseCasesSection/UseCases";
import SecondBanner from "../components/SecondBannerSection/SecondBanner";
import FAQ from "../components/FAQSection/FAQ";
import Footer from "../components/FooterSection/Footer";
import About from "../components/AboutSection/About";
import Solution from "../components/SolutionSection/Solution";
// import SeeDemo from "../components/SeeDemo/SeeDemo";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import Partners from "../components/PartnerSection/Partners";
import Benefits from "../components/BenefitsSection/Benefits";
import Features from "../components/FeaturesSection/Features";

export default function AgentSAIF() {
  return (
    <>
      <Header />
      {/* To use header component, you need to comment out the useEffect at line number 100 or provide section ids as mentioned in line number 13 */}
      <Banner />
      <Partners />
      <About />
      <Solution />
      <HowItWorks />
      <ROI />
      <Features />
      <UseCases />
      <Benefits />
      {/* <SeeDemo /> */}
      <FAQ />
      <SecondBanner />
      <Footer />
    </>
  );
}
